import { el } from './dom.js';

/**
 * The mark is the manille itself — the 10, the card the whole game is named
 * after — sitting at the front of a small fan. Inline SVG so it scales, themes
 * with the page and costs no extra request.
 */
export function logoElement(): HTMLElement {
  const node = el('div', 'logo');
  node.innerHTML = `
    <svg class="logo__mark" viewBox="0 0 64 56" role="img" aria-label="Manille">
      <g transform="translate(32 44)">
        <g transform="rotate(-22)">
          <rect x="-11" y="-34" width="22" height="32" rx="3.5"
                fill="#e8e2d6" stroke="rgb(0 0 0 / 0.25)" stroke-width="0.6" />
        </g>
        <g transform="rotate(-8)">
          <rect x="-11" y="-36" width="22" height="34" rx="3.5"
                fill="#f4efe4" stroke="rgb(0 0 0 / 0.25)" stroke-width="0.6" />
        </g>
        <g transform="rotate(9)">
          <rect x="-12" y="-38" width="24" height="36" rx="4"
                fill="#fbf8f1" stroke="rgb(0 0 0 / 0.3)" stroke-width="0.6" />
          <text x="-8.4" y="-27.5" font-size="9" font-weight="800"
                font-family="ui-rounded, -apple-system, Segoe UI, Roboto, sans-serif"
                fill="#cc2f45">10</text>
          <path d="M2.2 -14.4c-4-2.9-6.3-5.1-6.3-7.8a3 3 0 0 1 6.3-1.5 3 3 0 0 1 6.3 1.5c0 2.7-2.3 4.9-6.3 7.8z"
                fill="#cc2f45" transform="translate(-2.2 2)" />
        </g>
      </g>
    </svg>
    <span class="logo__word">Manille</span>
  `;
  return node;
}
